//cms页面地址
// export const cmsPathList = [
//   "/mk/tigergallery",
//   "/mk/tigergallery-mb",
// ];
// export const oldCmsPathList = [
//   "/patou/event",
//   "/patou/event-mb",
// ];

// 新cms 需要-mb
export const cmsPathList = [
  "/mk/tigergallery",
  "/mk/tigergallery-mb",
];

// 老cms
export const oldCmsPathList = [
  "/patou/event",
  "/brand/yellow-collection",
  "/brand/yellow-collection/store",
];
